import { APP_TYPE_PROSPECT, APP_TYPE_STAPPENPLAN, APP_TYPE_WIJZIGEN } from '@/constants';
import collectivity from '@/store/modules/collectivity';
import hospitals from '@/store/modules/hospitals';
import hospitalcontracts from '@/store/modules/hospitalcontracts';
import login from '@/store/modules/login';
import medischevragen from '@/store/modules/medischevragen';
import pakketten from '@/store/modules/pakketten';
import prefill from '@/store/modules/prefill';
import renderInfo from '@/store/modules/renderInfo';
import stappenplan from '@/store/modules/stappenplan';
import tvkeuzehulp from '@/store/modules/tvkeuzehulp';
import users from '@/store/modules/users';

const createStore = app => {
    const state = {
        userIndex: null,
        pending: false,
        pendingProducten: false,
        componentError: false,
        error: false
    };

    const getters = {
        getUserIndex: state => state.userIndex,
        getPendingStatus: state => state.pending,
        getPendingProductenStatus: state => state.pendingProducten,
        getComponentErrorStatus: state => state.componentError,
        getErrorStatus: (state, _getters, _rootState, rootGetters) => {
            return state.error || rootGetters['login/getErrorStatus'];
        }
    };

    const actions = {
        setUserIndex: ({ commit, dispatch, rootGetters }, index) => {
            commit('SET_USER_INDEX', index);

            switch (rootGetters['renderInfo/getAppType']) {
                // Fetch new products in prospect and change flow when needed
                case APP_TYPE_PROSPECT:
                case APP_TYPE_WIJZIGEN:
                    dispatch('pakketten/ophalen');
                    break;
                case APP_TYPE_STAPPENPLAN:
                    // Clear suggestion when changing user
                    // To prevent incorrect data being shown
                    dispatch('stappenplan/clearSuggestionByIndex', index);
            }
        },
        setPendingProductenStatus: ({ commit }, payload) => {
            commit('SET_PENDING_PRODUCTEN', payload);
        },
        setPendingStatus: ({ commit }, payload) => {
            commit('SET_PENDING', payload);
        },
        setErrorStatus: ({ commit }, payload) => {
            commit('SET_ERROR', payload);
        },
        setComponentErrorStatus: ({ commit }, payload) => {
            commit('SET_COMPONENT_ERROR', payload);
        },
        // Bij wisselen van propositie OF app type (wijzigen of prospect) moet het volgende worden geleegd:
        // - pakketten: dit voorkomt dat er pakketten van de verkeerde funnel worden getoond (bv: ZieZo funnel die ZK pakketten toont).
        // - users: pakketten en pakketkeuzes zijn afhankelijk van elkaar.
        // - collectiviteitzoeker: zoekresultaten en allianties.
        // - collectiviteit: dit voorkomt dat pakketten worden opgehaald met een collectiviteitsnummer van een andere propositie (bv: ZieZo pakketten ophalen van met een AON collectiviteit)
        //   OF dat er een aanmelding wordt gedaan met een collectiviteitsnummer van een ander propositie (bv: ZieZo aanmelding met een AON collectiviteit)
        clearStore: ({ dispatch }) => {
            dispatch('pakketten/clear');
            dispatch('users/clear');
            dispatch('prefill/clearCollectiviteit');
            dispatch('pakketten/clearCollectiviteit');
            dispatch('collectivity/clearZoekResultaten');
            dispatch('collectivity/clearAllianties');
            dispatch('renderInfo/resetAppContext');
        }
    };

    const mutations = {
        SET_USER_INDEX: (state, index) => {
            state.userIndex = index;
        },
        SET_PENDING_PRODUCTEN(state, payload) {
            state.pendingProducten = payload;
        },
        SET_PENDING(state, payload) {
            state.pending = payload;
        },
        SET_ERROR(state, payload) {
            state.error = payload;
        },
        SET_COMPONENT_ERROR(state, payload) {
            state.componentError = { ...state.componentError, ...payload };
        }
    };

    const plugins = [];

    return {
        strict: process.env.NODE_ENV !== 'production',
        modules: {
            pakketten: pakketten(app),
            users: users(app),
            login: login(app),
            renderInfo: renderInfo(app),
            hospitals: hospitals(app),
            hospitalcontracts: hospitalcontracts(app),
            tvkeuzehulp: tvkeuzehulp(app),
            medischevragen,
            prefill: prefill(app),
            collectivity: collectivity(app),
            stappenplan: stappenplan(app)
        },
        plugins,
        state,
        getters,
        actions,
        mutations
    };
};

export const rootStoragePaths = ['userIndex'];

export default app => createStore(app);
